/* ==========================================================================
   <cheo-size-guide> — guía de tallas (Calzado Cheo)

   Modal en desktop y hoja inferior en móvil, con la misma tabla en los dos casos
   (design/screenshots 11 y 13). Es de consulta, no un paso del flujo: no añade
   botones de acción y se cierra con ✕, con clic en el fondo o con Esc.

   Usa el <dialog> nativo, así que el atrapado de foco, la devolución del foco al
   disparador y el cierre con Esc los da el navegador. Lo único que añadimos es el
   cierre por clic en el fondo y el resaltado de la fila de la talla elegida.

   El disparador se escucha delegado en el documento a propósito: vive dentro de
   `variant-selects` y Dawn reemplaza ese nodo completo en cada cambio de
   variante, así que un listener puesto sobre el botón moriría en el primer
   cambio de color.
   ========================================================================== */

class CheoSizeGuide extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.dialog.addEventListener('click', (event) => {
      /* Clic en el fondo: el <dialog> ocupa toda la ventana, el panel es su hijo. */
      if (event.target === this.dialog) this.close();
    });

    this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.close());
  }

  open() {
    if (!this.dialog) return;
    this.highlightSelectedSize();
    this.dialog.showModal();
  }

  close() {
    this.dialog?.close();
  }

  /* La tabla la escribe el merchant (página o metafield), así que no podemos
     pedirle clases: buscamos la fila cuya primera celda coincide con la talla
     elegida. Si no hay talla confirmada todavía, no se resalta nada. */
  highlightSelectedSize() {
    const rows = this.querySelectorAll('table tr');
    rows.forEach((row) => row.classList.remove('is-selected'));

    const form = document.querySelector('cheo-product-form:not([data-size-pending])');
    const selected = form?.querySelector('[data-size-group] input:checked')?.value?.trim();
    if (!selected) return;

    rows.forEach((row) => {
      const cell = row.querySelector('td, th');
      if (cell && cell.textContent.trim() === selected) row.classList.add('is-selected');
    });
  }
}

if (!customElements.get('cheo-size-guide')) {
  customElements.define('cheo-size-guide', CheoSizeGuide);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-size-guide-open]');
  if (!trigger) return;

  const guide = document.getElementById(trigger.dataset.sizeGuideOpen);
  if (!guide?.open) return;

  event.preventDefault();
  guide.open();
});
